import { Link, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { useAuth, dashboardPath } from "../context/AuthContext";
import api from "../lib/api";
import { Button } from "./ui/button";
import { LayoutDashboard, LogOut, MessageSquare, Store, Truck, Users } from "lucide-react";

export const Navbar = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [unread, setUnread] = useState(0);

  useEffect(() => {
    if (user && user.role !== "admin") {
      api.get("/inquiries/unread-count").then((r) => setUnread(r.data.count)).catch(() => {});
    }
  }, [user]);

  const handleLogout = async () => {
    await logout();
    navigate("/");
  };

  return (
    <header className="sticky top-0 z-50 bg-white border-b border-foreground" data-testid="navbar">
      <div className="max-w-7xl mx-auto px-2 sm:px-6 h-16 flex items-center justify-between gap-1">
        <Link to="/" className="flex items-center gap-1.5 group shrink-0" data-testid="navbar-logo">
          <div className="h-8 w-8 bg-primary flex items-center justify-center shrink-0">
            <span className="font-display font-black text-white text-lg leading-none">W</span>
          </div>
          <span className="font-display font-bold text-sm sm:text-xl tracking-tight whitespace-nowrap">WILTOM TradeLink</span>
        </Link>

        <nav className="flex items-center gap-0.5 sm:gap-2">
          <Link to="/marketplace" data-testid="nav-marketplace">
            <Button variant="ghost" className="rounded-none font-medium px-2 sm:px-4">
              <Store className="h-4 w-4 sm:mr-1" /> <span className="hidden sm:inline">Marketplace</span>
            </Button>
          </Link>
          <Link to="/transport" data-testid="nav-transport">
            <Button variant="ghost" className="rounded-none font-medium px-2 sm:px-4">
              <Truck className="h-4 w-4 sm:mr-1" /> <span className="hidden sm:inline">Transport</span>
            </Button>
          </Link>
          <Link to="/find-transporter" data-testid="nav-find-transporter">
            <Button variant="ghost" className="rounded-none font-medium px-2 sm:px-4">
              <Users className="h-4 w-4 sm:mr-1" /> <span className="hidden sm:inline">Find Transporter</span>
            </Button>
          </Link>

          {user ? (
            <>
              {!["admin", "company"].includes(user.role) && (
                <Link to="/inquiries" data-testid="nav-inquiries">
                  <Button variant="ghost" className="rounded-none relative px-2 sm:px-4">
                    <MessageSquare className="h-4 w-4 sm:mr-1" /> <span className="hidden sm:inline">Inquiries</span>
                    {unread > 0 && (
                      <span className="absolute -top-0.5 -right-0.5 sm:static sm:ml-1.5 inline-flex items-center justify-center h-4 min-w-4 px-1 bg-destructive text-white text-[10px] font-bold rounded-full" data-testid="nav-unread-badge">{unread}</span>
                    )}
                  </Button>
                </Link>
              )}
              <Link to={dashboardPath(user.role)} data-testid="nav-dashboard">
                <Button variant="ghost" className="rounded-none px-2 sm:px-4">
                  <LayoutDashboard className="h-4 w-4 sm:mr-1" /> <span className="hidden sm:inline">Dashboard</span>
                </Button>
              </Link>
              <Button onClick={handleLogout} variant="outline" className="rounded-none px-2 sm:px-3" data-testid="nav-logout">
                <LogOut className="h-4 w-4" />
              </Button>
            </>
          ) : (
            <>
              <Link to="/login" data-testid="nav-login">
                <Button variant="ghost" className="rounded-none font-medium px-2 sm:px-4">Log in</Button>
              </Link>
              <Link to="/register" data-testid="nav-register">
                <Button className="rounded-none bg-primary hover:bg-primary/90 font-medium px-2.5 sm:px-4 whitespace-nowrap">Get started</Button>
              </Link>
            </>
          )}
        </nav>
      </div>
    </header>
  );
};
